import {
    deleteNotification,
    getNotifications,
    getUnRenderNotifications,
    markAllAsRead,
    markSingleAsRead,
    removeNotifications,
    getUnreadNotifications,
} from './notification.action';
export { notificationReducer } from './notification.reducer';
export { watchNotification } from './notification.saga';

export const notificationActions = {
    getNotifications,
    getUnreadNotifications,
    removeNotifications,
    getUnRenderNotifications,
    markAllAsRead,
    markSingleAsRead,
    deleteNotification,
    /** End */
};
